import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm$selectedTransport, _vm$selectedTransport2, _vm$selectedTransport3;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Transportador (Opcional)",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 5;
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Razão Social",
      "label-for": "razaoSocial"
    }
  }, [_c('VueSelect', {
    ref: "buscarTransportadora",
    attrs: {
      "filterable": false,
      "state": _vm.validateTransportadoraState('razaoSocial'),
      "options": _vm.transportadoras
    },
    on: {
      "search": _vm.onSearchTransportadoras
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(typeof option.nome !== "string" ? "" : option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.selectedTransportador,
      callback: function callback($$v) {
        _vm.selectedTransportador = $$v;
      },
      expression: "selectedTransportador"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Pesquise uma transportadora ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CNPJ/CPF",
      "label-for": "cnpj_cpf"
    }
  }, [_vm.hasCnpjAlfanumerico((_vm$selectedTransport = _vm.selectedTransportador) === null || _vm$selectedTransport === void 0 ? void 0 : _vm$selectedTransport.cnpj_cpf) ? _c('b-form-input', {
    key: "".concat(_vm.keyToRender, "-alfa"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf",
      "value": _vm.formatCnpjAlfanumerico((_vm$selectedTransport2 = _vm.selectedTransportador) === null || _vm$selectedTransport2 === void 0 ? void 0 : _vm$selectedTransport2.cnpj_cpf)
    }
  }) : _c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##', '##.###.###/####-##'],
      expression: "['###.###.###-##', '##.###.###/####-##']"
    }],
    key: "".concat(_vm.keyToRender, "-numeric"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf",
      "value": (_vm$selectedTransport3 = _vm.selectedTransportador) === null || _vm$selectedTransport3 === void 0 ? void 0 : _vm$selectedTransport3.cnpj_cpf
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Veículo",
      "label-for": "veiculo"
    }
  }, [_c('VueSelect', {
    ref: "buscarNatureza",
    attrs: {
      "filterable": false,
      "options": _vm.veiculos,
      "state": _vm.validateTransportadoraState('endereco')
    },
    on: {
      "search": _vm.onSearchVeiculo
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " ")])];
      }
    }]),
    model: {
      value: _vm.selectedVehicle,
      callback: function callback($$v) {
        _vm.selectedVehicle = $$v;
      },
      expression: "selectedVehicle"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Selecione um veiculo ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.newTransportadorNfe",
      modifiers: {
        "newTransportadorNfe": true
      }
    }],
    ref: "add_transportador",
    staticClass: "btn btn-primary font-weight-bold w-100",
    staticStyle: {
      "font-size": "11px",
      "margin-top": "30px"
    }
  }, [_vm._v(" Novo Transportador ")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Frete",
      "label-for": "frete"
    }
  }, [_c('VueSelect', {
    ref: "buscarFrete",
    attrs: {
      "filterable": false,
      "options": _vm.fretesSearched,
      "state": _vm.validateTransportadoraState('frete')
    },
    on: {
      "search": _vm.onSearchFrete
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat(option.codigo, " - ").concat(option.descricao)) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s("".concat(option.codigo, " - ").concat(option.descricao)) + " ")])];
      }
    }]),
    model: {
      value: _vm.store.formTransportador.frete,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTransportador, "frete", $$v);
      },
      expression: "store.formTransportador.frete"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o tipo de frete ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "quantidade",
      "name": "quantidade",
      "state": _vm.validateTransportadoraState('quantidade')
    },
    model: {
      value: _vm.store.formTransportador.quantidade,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTransportador, "quantidade", $$v);
      },
      expression: "store.formTransportador.quantidade"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Espécie",
      "label-for": "especie"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "especie",
      "name": "especie",
      "state": _vm.validateTransportadoraState('especie')
    },
    model: {
      value: _vm.store.formTransportador.especie,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTransportador, "especie", $$v);
      },
      expression: "store.formTransportador.especie"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Marca",
      "label-for": "marca"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "marca",
      "name": "marca",
      "state": _vm.validateTransportadoraState('marca')
    },
    model: {
      value: _vm.store.formTransportador.marca,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTransportador, "marca", $$v);
      },
      expression: "store.formTransportador.marca"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Numeração",
      "label-for": "numeracao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "numeracao",
      "name": "numeracao",
      "state": _vm.validateTransportadoraState('numeracao')
    },
    model: {
      value: _vm.store.formTransportador.numeracao,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTransportador, "numeracao", $$v);
      },
      expression: "store.formTransportador.numeracao"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Peso Bruto",
      "label-for": "pesoBruto"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "pesoBruto",
      "name": "pesoBruto",
      "state": _vm.validateTransportadoraState('pesoBruto')
    },
    model: {
      value: _vm.store.formTransportador.pesoBruto,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTransportador, "pesoBruto", $$v);
      },
      expression: "store.formTransportador.pesoBruto"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Peso Líquido",
      "label-for": "pesoLiquido"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "pesoLiquido",
      "name": "pesoLiquido",
      "state": _vm.validateTransportadoraState('pesoLiquido')
    },
    model: {
      value: _vm.store.formTransportador.pesoLiquido,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formTransportador, "pesoLiquido", $$v);
      },
      expression: "store.formTransportador.pesoLiquido"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "newTransportadorNfe",
      "centered": "",
      "title": "Novo Transportador"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click() {
              cancel();
              _vm.resetNovoTransportadorForm();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "saveTransportador",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.saveTransportador
          }
        }, [_vm._v(" Confirmar ")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Razão Social",
      "label-for": "novoTransportadorNome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "novoTransportadorNome",
      "name": "novoTransportadorNome",
      "maxlength": "50",
      "required": ""
    },
    model: {
      value: _vm.nomeTransportador,
      callback: function callback($$v) {
        _vm.nomeTransportador = $$v;
      },
      expression: "nomeTransportador"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CNPJ/CPF",
      "label-for": "novoTransportadorCpfCnpj"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "novoTransportadorCpfCnpj",
      "name": "novoTransportadorCpfCnpj"
    },
    nativeOn: {
      "input": function input($event) {
        return _vm.onCpfCnpjInput($event, _vm.$data, 'cpfCnpjTransportador');
      }
    },
    model: {
      value: _vm.cpfCnpjTransportador,
      callback: function callback($$v) {
        _vm.cpfCnpjTransportador = $$v;
      },
      expression: "cpfCnpjTransportador"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };